__turbopack_context__.v({
  "Cont": "Intro-module-sass-module__K49NtG__Cont",
  "Excerpt": "Intro-module-sass-module__K49NtG__Excerpt",
  "Icon": "Intro-module-sass-module__K49NtG__Icon",
  "Info": "Intro-module-sass-module__K49NtG__Info",
  "Intro": "Intro-module-sass-module__K49NtG__Intro",
});
